module.exports = __webpack_public_path__ + "img/edit.fe8d495b.png";